import { Component, OnInit, ElementRef, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-field-password',
  templateUrl: './field-password.component.html',
  styleUrls: ['./field.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class UiFieldPasswordComponent implements OnInit {
  showPass = false;
  showTypeAttr;
  searchTypeAttr;

  constructor(private el: ElementRef) {}

  ngOnInit() {}

  changeType() {
    this.showPass = !this.showPass;
    this.searchTypeAttr = this.showPass ? 'password' : 'text';
    this.showTypeAttr = this.showPass ? 'text' : 'password';

    this.el.nativeElement.querySelector('input[type="' + this.searchTypeAttr + '"]').setAttribute('type', this.showTypeAttr);
  }
}
